import { Record } from 'immutable'
import {IAdminWelcomeEmail} from 'store/entities/adminWelcomeEmail/interface';

export const AdminWelcomeEmailRecord = Record<IAdminWelcomeEmail>({
  text: null,
  description: null,
  quoteImage: null,
  quoteImageWidth: 450,
  subject: null,
})

export class AdminWelcomeEmail extends AdminWelcomeEmailRecord {
  constructor(props?: any) {
    super(props)
  }
}
